import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { ButtonDigited } from "../Button/Button.variants";


export function SideBarBoxRestyle({
  title,
  titleButtonHeader,
  actionButtonHeader,
  children,
  isRTL = false
}:{
  title:string,
  titleButtonHeader?:string,
  actionButtonHeader?:() => void,
  children:ReactNode,
  isRTL?: boolean
}){
  const slug = title.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "section";
  return (
    <Box
      id={ `sidebar-section-${slug}` }
      data-testid="sidebar-section"
      role="region"
      tabIndex={ 0 }
      aria-label={ title }
      display={ "flex" }
      flexDirection={ "column" }
      gap={ "1rem" }
    >
      <Box
        tabIndex={ -1 }
        sx={ {
          display: "flex",
          justifyContent: "space-between",
          alignItems:"center",
          flexDirection: isRTL ? "row-reverse" : "row"
        } }
      >
        <Typography
          data-testid="sidebar-section-title"
          tabIndex={ -1 }
          fontSize="0.87rem"
          fontWeight={ 500 }
          sx={ {
            lineHeight: 1,
            textAlign: isRTL ? "right" : "left"
          } }
        >
          { title }
        </Typography>

        { titleButtonHeader && (
          <ButtonDigited
            id={ `sidebar-section-${slug}-action` }
            data-testid="sidebar-section-action"
            aria-label={ titleButtonHeader }
            onClick={ () => actionButtonHeader && actionButtonHeader() }
            typology="tertiary"
            buttonSize="sm"
            text={ titleButtonHeader }
            sx={ {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            } }
          />
        ) }
      </Box>
      <Box>
        { children }
      </Box>
    </Box>
  );
}

